import { amountToUsFormat } from "@/shared/helpers"
import AddIcon from 'mdi-react/AddIcon';
import MinusIcon from 'mdi-react/MinusIcon';

export const TABLE_COLUMNS = [
    {
        id: 'expander',
        Header: ({getToggleAllRowsExpandedProps, isAllRowsExpanded}) => (
          <span {...getToggleAllRowsExpandedProps()}>
                {isAllRowsExpanded ? 'Collapse All' : 'Expand All'}
              </span>
        ),
        Cell: ({row}) =>
          row.canExpand ? (
            <span
              {...row.getToggleRowExpandedProps({
                style: {
                  paddingLeft: `${row.depth * 2}rem`,
                },
              })}
            >
                  {row.isExpanded ? <MinusIcon className="chevron-expand"/> : <AddIcon className="chevron-expand"/>}
                </span>
          ) : null,
        width: 125
    },
    {
        Header: "Program Name",
        accessor: "name",
    },
    {
        Header: "Total Participants",
        accessor: "participants_count",
    },
    {
        Header: "New Participants",
        accessor: "new_participants_count",
    },
    {
        Header: "Awards",
        accessor: "awards_count",
    },
    {
        Header: "Value",
        accessor: "awards_value",
        Cell: ({ row, value }) => { return `${amountToUsFormat(parseFloat(value), true, "$")}`}
    },
    {
        Header: "Average",
        accessor: "transaction_fees",
        Cell: ({ row, value }) => { return `${amountToUsFormat(parseFloat(value), true, "$")}`},
    },
    {
        Header: "MTD Awards",
        accessor: "mtd_awards_count",
    },
    {
        Header: "MTD Value",
        accessor: "mtd_awards_value",
        Cell: ({ row, value }) => { return `${amountToUsFormat(parseFloat(value),true,"$")}`},
    },
    {
        Header: "MTD Average",
        accessor: "mtd_transaction_fees",
        Cell: ({ row, value }) => { return `${amountToUsFormat(parseFloat(value),true,"$")}`},
    },
    {
        Header: "YTD Awards",
        accessor: "ytd_awards_count",
    },
    {
        Header: "YTD Value",
        accessor: "ytd_awards_value",
        Cell: ({ row, value }) => { return `${amountToUsFormat(parseFloat(value),true,"$")}`},
    },
    {
        Header: "YTD Average",
        accessor: "ytd_transaction_fees",
        Cell: ({ row, value }) => { return `${amountToUsFormat(parseFloat(value),true,"$")}`},
    },   
]